const middleware_controller = require("../middleware/middleware_controller");

let styleConstants = localStorage.getItem("style-constants");

const replaceConstants = (style, styleConstants) => {
    let results = {};
    if (!style) {
        return;
    }
    const styleKeys = Object.keys(style);
    try {
        for (let i = 0; i < styleKeys.length; i++) {
            try {
                const styleValue = style[styleKeys[i]];

                if (typeof styleValue == typeof {}) {
                    results[styleKeys[i]] = replaceConstants(
                        styleValue,
                        styleConstants
                    );
                } else {
                    if (styleConstants[styleValue]) {
                        results[styleKeys[i]] = styleConstants[styleValue];
                    } else {
                        results[styleKeys[i]] = styleValue;
                    }
                }
            } catch (e) {}
        }
    } catch (e) {}

    return results;
};

const styleWrap = (style, callback) => {
    try {
        styleConstants = localStorage.getItem("style-constants");
        const results = replaceConstants(style, JSON.parse(styleConstants));
        if (callback) {
            callback(results);
        }
        return results;
    } catch (e) {
        console.log(e);
    }
};

export default styleWrap;
